export const PROGRAMME_INITIAL_VALUES = {
  id: '',
  overview: {
    name: '',
    summary: '',
    theoryOfChange: '',
    isArchived: undefined,
    fromDate: null,
    toDate: null,
    serviceProviderIds: [],
    frameworkTypeId: undefined,
    geographies: [],
    ownerId: undefined,
    reporters: [],
    assignees: [],
    parentProgrammeId: undefined,
    childProgrammeIds: [],
    portfolioIds: [],
    theoryOfChangeFileId: undefined,
    budgetAmount: 0,
    currency: '',
    addOnIds: [],
    childBudget: 0,
  },
  indicators: {
    frameworkResults: [],
  },
  monitoring: {
    forms: [],
  },
};

export const PROGRAMME_OVERVIEW_ISARCHIVED_OPTIONS = [
  { label: 'Active', value: false },
  { label: 'Archived', value: true },
];

export const programmeSteps = [
  { id: 'overview', name: 'Overview' },
  { id: 'indicators', name: 'Indicators' },
  { id: 'monitoring', name: 'Monitoring' },
  { id: 'complete', name: 'Complete' },
];

export const GEOGRAPHY_LEVEL_OPTIONS = [
  { label: 'Country', value: 'COUNTRY' },
  { label: 'Province', value: 'PROVINCE' },
  { label: 'Education District', value: 'DISTRICT' },
  { label: 'Local Municipality', value: 'LOCAL_MUNICIPALITY' },
  { label: 'District Municipality', value: 'DISTRICT_MUNICIPALITY' },
  { label: 'Metro / City', value: 'METRO_CITY' },
];
